import styled from "styled-components";
import color from "../../assets/css/colors";

export const DropdownItem = styled.a`
    text-transform: none;
    font-size: 10px;
    cursor: pointer;
`

export const Container = styled.div`
    cursor: pointer;
`

export const Box = styled.div`
    position: absolute ;
    transform: translate(-100%, -70%);
    background: white;
    border-radius: 5px;
    padding: 10px 0;
    text-align: left;
    border: 1px solid rgba(0,0,0,.15)
`